<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <topbar :user="user" :toggle_aside="toggle_aside" v-model="toggle_aside" v-if="checkLoginStatus()"></topbar>
    <router-view :user="user" :toggle_aside="!toggle_aside" v-model="toggle_aside"></router-view>
  </div>
</template>

<script>
import TopBar from './components/Common/TopBar'

import { getCookie } from './assets/js/elffy_js/cookie.js'


export default {
  name: 'app',
  components: {
 
  },
  data() {
    return {
      user: '',
      toggle_aside: ''
    }
  },
  created() {
    this.getUserProfile()
    setInterval(() => this.getUserProfile(), 43200 * 1000);
  },
  mounted() {
    this.set_side_bar_status();
  },
  watch: {
    '$route' (to, from) {
      this.getUserProfile();
    }
  },
  methods: {
    checkLoginStatus(){
      var noCheckRoute = [
        'login',
        'signup',
        'verify_email',
        'reset_password',
        'accept_invitation'
      ]
      var router = this.$router.currentRoute.name

      return !noCheckRoute.includes(router)

    },
    set_side_bar_status() {
      if (getCookie('aside_bar') == 'false') {
        this.toggle_aside = false
      } else {
        this.toggle_aside = true
      }
    },
    getUserProfile() {
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      // defiine vm to assign this (assign vue data) because in axios there is other this
      const vm = this;
      this.axios.get('settings/get_user_profile').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.user = response['data']['data']['user']
          } else {
            console.log('User Profile Get Error')
            VueRouter.push('/login');
          }
        }).catch(function(error) {
        	console.log('error:', error)
        	VueRouter.push('/login');
      });
    },
  }
}

</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// App.vue?70194f3e